(function () {
  'use strict';
  if (window.HBOffer03Shipping) return;
  var shippingRoot = null, shippingBusy = false, shippingChoice = null;
  var checkoutLeaving = false, checkoutButton = null, checkoutLabel = '';
  var shippingCode = 'HB-AU-B2G1-SHIP', shippingStorage = 'hb-offer03-shipping-intent';
  try { shippingChoice = JSON.parse(sessionStorage.getItem(shippingStorage) || 'null'); } catch (e) { /* Storage is optional. */ }
  if (!shippingChoice) shippingChoice = { eligible: false, suppressed: false };
  function shippingIntent(eligible, resetSuppression) {
    shippingChoice = { eligible: !!eligible, suppressed: resetSuppression === false && !!(shippingChoice && shippingChoice.suppressed) };
    try { sessionStorage.setItem(shippingStorage, JSON.stringify(shippingChoice)); } catch (e) { /* Keep this page's choice. */ }
  }
  function shippingCodes(cart) {
    return (cart.discount_codes || []).map(function (entry) { return entry.code; }).filter(Boolean);
  }
  function shippingHas(codes, value) {
    return codes.some(function (code) { return code.toUpperCase() === value.toUpperCase(); });
  }
  async function shippingCart(base, codes) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (codes) {
      options.method = 'POST'; options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify({ discount: codes.join(',') });
    }
    var response = await fetch(base + (codes ? 'cart/update.js' : 'cart.js'), options);
    if (!response.ok) throw new Error('Could not prepare checkout. Please retry.');
    return response.json();
  }
  window.HBOffer03Shipping = { intent: shippingIntent, busy: function () { return shippingBusy; } };
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !checkoutLeaving) return;
    // Successful checkout navigation keeps its lock until this document returns.
    checkoutLeaving = false;
    shippingBusy = false;
    var drawer = document.getElementById('hbcd');
    var guarded = !drawer || drawer.dataset.offerUpdating === 'true' || drawer.dataset.offerBlocked === 'true';
    if (checkoutButton) {
      checkoutButton.textContent = checkoutLabel;
      checkoutButton.disabled = guarded;
    }
    document.dispatchEvent(new CustomEvent('hb-offer:checkout-state'));
    if (!guarded && window.HBCartDrawer && typeof window.HBCartDrawer.refresh === 'function') {
      Promise.resolve(window.HBCartDrawer.refresh()).catch(function () { /* Existing drawer state is preserved on read failure. */ });
    }
  });
  document.addEventListener('click', async function (event) {
    shippingRoot = document.querySelector('[data-hb-offer03]');
    var drawer = document.getElementById('hbcd');
    if (!drawer) return;
    if (event.target.closest('[data-hbcd-disc-rm]')) {
      if (shippingChoice) {
        shippingChoice.suppressed = true;
        try { sessionStorage.setItem(shippingStorage, JSON.stringify(shippingChoice)); } catch (e) { /* Keep local choice. */ }
      }
      return;
    }
    var button = event.target.closest('[data-hbcd-co]');
    if (!button || drawer.dataset.shippingCountry !== 'AU' || (drawer.dataset.offerShipping !== 'true' && !(shippingRoot && shippingChoice && shippingChoice.eligible)) || (shippingChoice && shippingChoice.suppressed)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (shippingBusy || drawer.dataset.offerUpdating === 'true' || drawer.dataset.offerBlocked === 'true') return;
    checkoutButton = button; checkoutLabel = button.textContent;
    shippingBusy = true; button.disabled = true; document.dispatchEvent(new CustomEvent('hb-offer:checkout-state'));
    var label = button.textContent, base = (window.Shopify && window.Shopify.routes.root) || '/';
    var notice = shippingRoot && shippingRoot.querySelector('[data-offer03-error]');
    button.textContent = 'Preparing checkout...';
    try {
      var cart = await shippingCart(base);
      var eligible = cart.items.some(function (line) { return Number(line.variant_id) === 44734505975896 && !line.selling_plan_allocation && ((line.properties && line.properties._hb_offer03 === 'v1') || (shippingRoot && shippingChoice && shippingChoice.eligible)); });
      if (eligible) {
        var before = shippingCodes(cart);
        if (!shippingHas(before, shippingCode)) {
          var codes = before.filter(function (code, index) { return before.findIndex(function (other) { return other.toUpperCase() === code.toUpperCase(); }) === index; });
          codes.push(shippingCode);
          var updated = await shippingCart(base, codes);
          var priorApplicable = (cart.discount_codes || []).filter(function (entry) { return entry.applicable; });
          var lost = priorApplicable.some(function (prior) {
            return !(updated.discount_codes || []).some(function (entry) { return entry.applicable && entry.code.toUpperCase() === prior.code.toUpperCase(); });
          });
          var shippingApplicable = (updated.discount_codes || []).some(function (entry) { return entry.applicable === true && entry.code.toUpperCase() === shippingCode.toUpperCase(); });
          if (lost || !shippingApplicable) {
            var restored = await shippingCart(base, before);
            var restoredCodes = shippingCodes(restored);
            var restoredExactly = restoredCodes.length === before.length && before.every(function (code) { return shippingHas(restoredCodes, code); });
            var restoredApplicable = priorApplicable.every(function (prior) {
              return (restored.discount_codes || []).some(function (entry) { return entry.applicable === true && entry.code.toUpperCase() === prior.code.toUpperCase(); });
            });
            shippingChoice.suppressed = true;
            try { sessionStorage.setItem(shippingStorage, JSON.stringify(shippingChoice)); } catch (e) { /* Keep local choice. */ }
            if (!restoredExactly || !restoredApplicable) throw new Error('We could not confirm your original discount was restored. Please check your bag before continuing.');
            throw new Error('Your discount choice was kept. Please check your bag and retry checkout; free shipping may not combine with that code.');
          }
        }
      }
      checkoutLeaving = true;
      window.location.assign(base + 'checkout');
    } catch (e) {
      checkoutLeaving = false;
      if (notice) { notice.textContent = e.message || 'Could not prepare checkout. Please retry.'; notice.hidden = false; }
      var checkoutNotice = button.parentNode.querySelector('[data-offer03-checkout-error]');
      if (!checkoutNotice) {
        checkoutNotice = document.createElement('p');
        checkoutNotice.setAttribute('data-offer03-checkout-error', '');
        checkoutNotice.setAttribute('role', 'status');
        button.parentNode.insertBefore(checkoutNotice, button);
      }
      checkoutNotice.textContent = e.message || 'Could not prepare checkout. Please retry.';
      button.textContent = 'Please retry checkout'; button.disabled = false; shippingBusy = false;
      if (notice) notice.scrollIntoView({ block: 'nearest' });
    } finally {
      if (!shippingBusy) { button.setAttribute('data-checkout-label', label); document.dispatchEvent(new CustomEvent('hb-offer:checkout-state')); }
    }
  }, true);
}());
